import React, { memo } from 'react';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

export const CasinoListSkeleton = memo(() => {
    const skeletonItems = Array.from({ length: 8 }, (_, index) => index);

    return (
        <Box p="s16">
            {skeletonItems.map(item => (
                <Box
                    key={item}
                    borderRadius="r20"
                    marginBottom={'s12'}
                    backgroundColor={ds.colorToken.background.neutral.subtle}
                >
                    <LoadingSkeleton skeletonColor={designSystem.colors.neutral300} borderRadius="r20" height={72} />
                </Box>
            ))}
        </Box>
    );
});
